import React from 'react';
import ReusableDemoPage from "../ReusableDemoPage";
import { zoomcarConfig } from '../demoConfigs';

const ZoomcarDemo = () => {
  return <ReusableDemoPage config={zoomcarConfig} />;
};

export default ZoomcarDemo;